import { render, staticRenderFns } from "./gallery-favourites.vue?vue&type=template&id=5e93dfd4&"
import script from "./gallery-favourites.vue?vue&type=script&lang=js&"
export * from "./gallery-favourites.vue?vue&type=script&lang=js&"
import style0 from "./gallery-favourites.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports